import React, { useEffect, useState } from 'react'
import {
	Title,
	PaymentContainer,
	CardLabel,
	LabelError,
	FormGroup,
} from './PayPalForm.styles'

const styles = {
	field: {
		border: 'none',
		backgroundColor: '#F5F7FA',
		borderRadius: '6px',
		height: '40px',
		fontWeight: '600',
		padding: '0 15px',
		fontFamily: 'Montserrat, sans-serif, Arial',
		fontStyle: 'normal',
		fontSize: '16px',
		lineHeight: '28px',
		display: 'flex',
		alignItems: 'center',
		color: '#64778F',
	},
}

type ErrorProps = { [key: string]: { [key: string]: string } }

const items = ['number', 'cvv', 'expirationDate']

const messages: ErrorProps = {
	number: {
		empty: 'El número de tarjeta es obligatorio.',
		invalid: 'El número de tarjeta no es válido.',
	},
	cvv: {
		empty: 'El código de seguridad es obligatorio.',
		invalid: 'El código de seguridad no es válido.',
	},
	expirationDate: {
		empty: 'La fecha de expiración es obligatoria.',
		invalid: 'La fecha de expiración no es válida.',
	},
}

export const PayPalForm = ({
	children,
	invalidFields,
	emptyFields,
}: any): JSX.Element => {
	const [errorMessage, setErrorMessage] = useState<ErrorProps>({
		number: { message: '' },
		cvv: { message: '' },
		expirationDate: { message: '' },
	})

	useEffect(() => {
		items.forEach((item: string) => {
			if (emptyFields.includes(item)) {
				errorMessage[item] = { message: messages[item].empty }
			} else if (invalidFields.includes(item)) {
				errorMessage[item] = { message: messages[item].invalid }
			} else {
				errorMessage[item] = { message: '' }
			}
		})

		setErrorMessage({ ...errorMessage })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [invalidFields])

	return (
		<>
			<Title>Agrega una tarjeta de débito o crédito</Title>
			<PaymentContainer>
				<div>
					<FormGroup>
						<CardLabel htmlFor="number">Número de tarjeta</CardLabel>
						<div id="card-number" style={styles.field}></div>
						<LabelError
							visible={
								emptyFields.includes('number') ||
								invalidFields.includes('number')
							}
						>
							{errorMessage.number.message}
						</LabelError>
					</FormGroup>
					<FormGroup>
						<CardLabel htmlFor="expiration-date">Vigencia</CardLabel>
						<div id="expiration-date" style={styles.field}></div>
						<LabelError
							visible={
								emptyFields.includes('expirationDate') ||
								invalidFields.includes('expirationDate')
							}
						>
							{errorMessage.expirationDate.message}
						</LabelError>
					</FormGroup>
					<FormGroup>
						<CardLabel htmlFor="cvv">CVV</CardLabel>
						<div id="cvv" style={styles.field}></div>
						<LabelError
							visible={
								emptyFields.includes('cvv') || invalidFields.includes('cvv')
							}
						>
							{errorMessage.cvv.message}
						</LabelError>
					</FormGroup>
					{children}
				</div>
			</PaymentContainer>
		</>
	)
}
